<div class="card mb-4">
    <div class="card-body">
        <div class="row">
            <div class="col-12 card-title">
                <h4>Active Memberships</h4>

                <!-- Desktop Table View -->
                <div class="table-responsive d-none d-sm-block">
                    <table msResponsiveTable class="table table-sm">
                        <thead>
                            <tr>
                                <th msResponsiveTableColumn="organization" [priority]="1">Organizations</th>
                                <th msResponsiveTableColumn="role" [priority]="2">Role</th>
                                <th msResponsiveTableColumn="lastLogin" [priority]="3">Last Login</th>
                                <th msResponsiveTableColumn="actions" [priority]="1">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if (memberships()?.length == 0) {
                            <tr>
                                <td colspan="4" class="text-center text-muted py-4">No active memberships found.</td>
                            </tr>
                            }
                            @else {
                            @for (membership of memberships(); track membership.organizationId) {
                            <tr>
                                <td msResponsiveTableColumn="organization" [priority]="1">{{membership.organizationName}}</td>
                                <td msResponsiveTableColumn="role" [priority]="2">{{membership.role}}</td>
                                <td msResponsiveTableColumn="lastLogin" [priority]="3">{{membership.lastLogin | orgDate:'MMM dd, yyyy h:mm a' | noValue : "Never" }}</td>
                                <td msResponsiveTableColumn="actions" [priority]="1">
                                    <div class="dropdown">
                                        <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown">
                                            Actions
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li>
                                                <a class="dropdown-item" (click)="viewOrganization(membership.organizationId)">
                                                    <fa-duotone-icon icon="building" primaryOpacity="0.2" secondaryOpacity="0.9" class="me-2" />View Organization
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" (click)="viewMemberProfile(membership.memberId)">
                                                    <fa-duotone-icon icon="user" secondaryOpacity="0.9" class="me-2" />Go to Member Profile
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                            }
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Mobile Card View -->
                <div id="mobileTableCards" class="d-block d-sm-none">
                    @for (membership of memberships(); track membership.organizationId) {
                    <div class="card d-flex pt-1 d-inline d-sm-none my-3">
                        <div class="d-flex flex-column card-body">
                            <div class="d-flex flex-row">
                                <div>
                                    <h5 class="card-title mb-2">{{membership.organizationName}}</h5>
                                    <div class="card-text text-muted small mb-0">
                                        Role: <span class="fw-normal">{{membership.role}}</span>
                                        <br />
                                        Last Login: <span class="fw-normal">{{membership.lastLogin | orgDate:'MMM dd, yyyy h:mm a' | noValue : "Never" }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown">
                            Actions
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end w-75">
                            <li>
                                <a class="dropdown-item" (click)="viewOrganization(membership.organizationId)">
                                    <fa-duotone-icon icon="building" primaryOpacity="0.2" secondaryOpacity="0.9" class="me-2" />View Organization
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" (click)="viewMemberProfile(membership.memberId)">
                                    <fa-duotone-icon icon="user" secondaryOpacity="0.9" class="me-2" />Go to Member Profile
                                </a>
                            </li>
                        </ul>
                    </div>
                    }
                </div>

            </div>
        </div>
    </div>
</div>